/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_View_All_ToolsInputs */

const en_directory_launch_view_all_tools = /** @type {(inputs: Directory_Launch_View_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all tools`)
};

const zh_directory_launch_view_all_tools = /** @type {(inputs: Directory_Launch_View_All_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部工具`)
};

/**
* | output |
* | --- |
* | "View all tools" |
*
* @param {Directory_Launch_View_All_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_view_all_tools = /** @type {((inputs?: Directory_Launch_View_All_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_View_All_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_view_all_tools(inputs)
	return zh_directory_launch_view_all_tools(inputs)
});
export { directory_launch_view_all_tools as "directory.launch.view_all_tools" }